import { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Navigation, Autoplay } from "swiper/modules";
import { FaInstagram } from "react-icons/fa6";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "./css/Films.css";

export default function Films() {
  // const upcomingFilms = [
  //   { title: "Coming Soon", file: "/images/upcoming_films/shadow_poster.jpg", type: "image" },
  //   { title: "Coming Soon", file: "/images/upcoming_films/shadow_poster.jpg", type: "image" },
  //   { title: "Coming Soon", file: "/images/upcoming_films/shadow_poster.jpg", type: "image" },
  // ];

  const upcomingTrailers = [
    {
      title: "AVP Production Reel",
      file: "/videos/new_project_18thaug.mp4",
      type: "video",
      instagramUrl: "https://www.instagram.com/reel/DTXtSZKEvDQ/",
    },
    { title: "Coming Soon", file: "/videos/IMG_5946.MP4", type: "video" },
  ];

  const [activeIndex, setActiveIndex] = useState(0);
  const activeFilm = upcomingTrailers[activeIndex];

  const handleSlideChange = (swiper) => {
    const index = swiper.realIndex;
    setActiveIndex(index);
    if (upcomingTrailers[index]?.instagramUrl) {
      swiper.autoplay.stop();
    } else {
      swiper.autoplay.start();
    }
  };

  return (
    <div className="films-page">
      <h2 className="films-heading">Upcoming Films</h2>
      <Swiper
        modules={[Pagination, Navigation, Autoplay]}
        pagination={{ clickable: true }}
        navigation
        autoplay={{
          delay: 3000,
          disableOnInteraction: false,
        }}
        onInit={handleSlideChange}
        onSlideChange={handleSlideChange}
        spaceBetween={20}
        slidesPerView={1}
        loop={true}
        className="films-slider"
      >
        {upcomingTrailers.map((film, index) => (
          <SwiperSlide key={index}>
            <div className="film-slide">
              {film.type === "image" ? (
                <img src={film.file} alt={film.title} />
              ) : (
                <video src={film.file} controls autoPlay muted loop playsInline />
              )}
            </div>
          </SwiperSlide>
        ))}
      </Swiper>

      {activeFilm?.instagramUrl && (
        <a
          href={activeFilm.instagramUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="instagram-cta"
        >
          <FaInstagram />
          View on Instagram
        </a>
      )}
    </div>
  );
}
